
// pocketGitaApi.js
// Minimal API client for the Pocket Gita MVP (plain JS)

const DEFAULT_API = 'http://localhost:5000/gita';
  // process.env.EXPO_PUBLIC_API_URL ||
  // process.env.REACT_APP_POCKET_GITA_API ||
  // 'http://localhost:5050';

export const API = DEFAULT_API;

async function ok(res) {
  if (!res.ok) {
    let detail = null;
    try { detail = await res.json(); } catch {}
    const msg = (detail && (detail.detail || detail.message)) || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return res.json();
}

export async function getMeta() {
  const res = await fetch(`${API}/api/meta`, { method: 'GET' });
  return ok(res);
}

export async function getPage(n) {
  const res = await fetch(`${API}/api/page/${n}`, { method: 'GET' });
  return ok(res);
}

export async function shuffle(mode = 'daily') {
  const res = await fetch(`${API}/api/shuffle?mode=${mode}`, { method: 'GET' });
  return ok(res);
}
